
<div class="overlay-container" >
</div>
<div class="modal show" id="myModal"  [ngClass]="isPopupOpen?'show':'hide'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
     <div class="modal-body">
        <button type="button" class="close popupClose" data-dismiss="modal" (click)="close()"><img src="{{globalService.staticResourceURL}}/assets/images/Icon-icon-placeholder.svg" class="img-fluid"></button>
        <div id="addorUpdat" class="mt-4 mb-4">Add or Update Insurance</div>
         <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
         {{errorMessage}}
        </div>
          <form autocomplete="off" class="text-left" [formGroup]="insuranceForm">
            <div class="row no-margin">
                <div class="col-12 col-sm-6 mb-3">
                      <label for="companyName" class="lblPin">Insurance Company(Max 40 Chars)</label>
                      <input type="text"  size="40" maxlength="40" class="form-control"  formControlName="companyName" class="form-control"   [ngClass]="{ 'is-invalid': submitted && f.companyName.errors }">
                    <div *ngIf="submitted && f.companyName.errors?.required"  class="invalid-feedback">Please enter name of
insurance company.</div>
                    <div class="invalid-feedback" *ngIf="submitted && f.companyName.errors?.pattern">Invalid symbols found.  Please retry.</div>
                </div>
                  
                
                <div class="col-12 col-sm-6 mb-3">
                      <label for="companyCode" class="lblPin">Insurance Company Code (5 digits)</label>
                      <input type="text"  formControlName="companyCode" maxlength="5" class="form-control"  [ngClass]="{ 'is-invalid': submitted && f.companyCode.errors }">
                    <div *ngIf="submitted && f.companyCode.errors"  class="invalid-feedback"> Please enter a 5-digit
insurance company code.</div>
                </div>
                  
                <div class="col-12 col-sm-6 mb-3">
                 <label for="policyNumber" class="lblPin">Policy Number(Max 30 Chars)</label>
                  <div class="input-group date">
                        <input type="text" size="30" maxlength="30" class="form-control" formControlName="policyNumber" class="form-control"   [ngClass]="{ 'is-invalid': submitted && f.policyNumber.errors }">
                      <div *ngIf="submitted && f.policyNumber.errors?.required"  class="invalid-feedback">Please enter insurance policy number</div>
                      <div class="invalid-feedback" *ngIf="submitted && f.policyNumber.errors?.pattern">Invalid symbols found.  Please retry.</div>
                    </div>
                </div>   
                
                <div class="col-12 col-sm-6 mb-3"></div>
                
                <div class="col-12 col-sm-12 mt-3">
                    <div class="checkbox-container checkbox-container-insurance">
                        <label id="fLInsuranc">FL Insurance Affidavit
                            <input type="checkbox" checked="checked" formControlName="insuranceAffidavit" [ngClass]="{ 'is-invalid': submitted && !f.insuranceAffidavit.value }">
                            <span class="checkmark checkmarkIns" [ngStyle]="f.insuranceAffidavit.value?{'background-color':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor} : {'background-color': 'transparent'}"
                           [style.border-color]="(submitted && !f.insuranceAffidavit.value)? '#dc3545':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"></span>
                           <div id="unerpenalt">Under penalty of perjury, I certify that I have Personal Injury Protection, Property Damage Liability, and, when required, Bodily Injury Liability coverage, for this vehicle. I understand that my driver’s license, license plate(s) and registration(s) will be suspended if this information is invalid. WARNING: Giving false information in order to obtain a vehicle registration certificate is a criminal offense and subject to prosecution.</div>
                           
                        </label> 
                         <div *ngIf="submitted && !f.insuranceAffidavit.value"  class="invalid-feedback insuranceAffidavitError" style="display:block">Please certify
the FL Insurance Affidvit by checking the checkbox.</div>

                           
                    </div> 
                  
                </div> 
                
              </div>          

              </form>
              <div class="mb-5">
                                <a>
                                    <button class="btn btn-primary btn-commonbtn m-auto" (click)="addEdit()">Add </button>
                                </a>
                         </div>
      </div>

    </div>
  </div>
</div>